/*
 * @Description: H5方法封装
 */
import h5RecordApi from './h5-record'
import h5OthersApi from './h5-others'
import h5MapApi from './h5-map'
import h5PlusreadyApi from './h5-plusready'
import h5EnvFunApi from './h5-envFun'

const init = async () => {
  return true
}

/**
 * 本地存储设置，带过期时间
 * @param data.key 键
 * @param data.value 值
 * @param data.expiryInMinutes 过期时间，单位分钟, 可选
 */
const xbbLocalStorageSet = (data) => {
  let val = data.value
  if (data.expiryInMinutes) {
    const now = new Date()
    const item = {
      value: data.value,
      expiry: now.getTime() + data.expiryInMinutes * 60 * 1000 // 转换为毫秒
    }
    val = JSON.stringify(item)
  }
  window.plus.storage.setItem(data.key, val)
}
/**
 * 本地存储获取
 * @param data.key 键
 * @returns 值
 */
const xbbLocalStorageGet = (data) => {
  const itemStr = window.plus.storage.getItem(data.key)

  // 如果没有数据，返回 null
  if (!itemStr) {
    return null
  }

  let parsed
  try {
    if (data.key === 'userId') {
      return itemStr
    }
    parsed = JSON.parse(itemStr)
  } catch (e) {
    // 不是 JSON，直接返回原始字符串
    return itemStr
  }

  const now = Date.now()

  // 如果是带 expiry 的存储格式，检查是否过期
  if (parsed && typeof parsed === 'object' && 'expiry' in parsed) {
    if (now > parsed.expiry) {
      window.plus.storage.removeItem(data.key)
      return null
    }
    return parsed.value
  }

  // 不是带 expiry 的对象或是 JSON 序列化的原始值，直接返回解析结果
  return parsed
}

const xbbLocalStorageRemove = (data) => window.plus.storage.removeItem(data.key)

const xbbLocalStorageClear = () => window.plus.storage.clear()

export default {
  ...h5RecordApi,
  ...h5OthersApi,
  ...h5MapApi,
  ...h5PlusreadyApi,
  ...h5EnvFunApi,
  xbbLocalStorageSet,
  xbbLocalStorageGet,
  xbbLocalStorageRemove,
  xbbLocalStorageClear,
  init
}
